enum ListSortOrderEnum {
    Ascending = 'ASC',
    Descending = 'DESC',
}

export default ListSortOrderEnum;
